/**
 * Lenz · Reveal al hacer scroll
 *
 * Anima cada sección de la página al entrar en el viewport, y dentro de las
 * que son grilla o lista escalona sus hijos.
 *
 * Decisiones que importan:
 *
 *   - LA PRIMERA SECCIÓN NO SE ANIMA. Es el hero, está sobre el pliegue y
 *     contiene el LCP de la página. Ocultarlo para después revelarlo
 *     retrasaría la métrica que venimos cuidando y, peor, le mostraría al
 *     visitante una pantalla vacía en el primer instante.
 *
 *   - El estado oculto lo agrega este script, nunca el HTML. Si esto no
 *     corre, la página se ve entera. Ver el comentario de lenz-reveal.css.
 *
 *   - Las grillas se declaran explícitamente abajo. Se probó detectarlas
 *     solas ("un contenedor con varios hijos parecidos") y en esta página
 *     eso agarraba también el carrusel de marketplaces, que tiene 26
 *     elementos: escalonarlos daba una cascada larguísima. Una lista
 *     explícita es menos elegante pero no falla en silencio.
 *
 *   - one-shot: se deja de observar apenas entra. Volver a animar al
 *     subir y bajar marea.
 */
(function () {
  'use strict';

  if (window.__lenzRevealBoot) return;
  window.__lenzRevealBoot = true;

  // Contenedores cuyos hijos entran escalonados. El orden no importa.
  var GRILLAS = [
    '.lzv2-brgrid',    // logos de marcas
    '.lzv2-tl3',       // línea de tiempo de la historia
    '.lzv2-h2ic',      // cabecera del equipo
    '.multi-column',   // tarjetas del equipo
    '.lzv2-comm__row', // comunidad
    '.lzv2-visit'      // visítanos / info
  ];

  // La línea de tiempo entra de costado en vez de desde abajo.
  var LATERALES = ['.lzv2-tl3'];

  var PASO_MS = 70;   // retardo entre hijos
  var TOPE_MS = 560;  // techo del escalonado: con muchos hijos, el último no
                      // puede quedar esperando medio segundo de más

  function marcarHijos(seccion) {
    for (var i = 0; i < GRILLAS.length; i++) {
      var grilla = seccion.querySelector(GRILLAS[i]);
      // Mínimo 3 hijos para considerarlo grilla. Sin esta guarda ganaba por
      // orden de lista el primer selector presente aunque tuviera un solo
      // hijo: en la sección de info, .lzv2-h2ic (1 hijo) le robaba el turno
      // a .lzv2-visit (3 chips), que era la grilla de verdad.
      if (!grilla || grilla.children.length < 3) continue;
      var lateral = LATERALES.indexOf(GRILLAS[i]) !== -1;
      var hijos = grilla.children;
      for (var j = 0; j < hijos.length; j++) {
        hijos[j].classList.add('lenz-rv-item');
        if (lateral) hijos[j].classList.add('lenz-rv-item--side');
        var retardo = Math.min(j * PASO_MS, TOPE_MS);
        hijos[j].style.transitionDelay = retardo + 'ms';
      }
      return; // una grilla por sección alcanza
    }
  }

  function init() {
    var main = document.querySelector('main') || document.body;
    // Solo las secciones de ESTA plantilla. Shopify las nombra
    // "shopify-section-template--...", mientras que las compartidas de todo
    // el sitio son "sections--...". La distinción importa por dos motivos
    // concretos, ambos verificados en vivo:
    //   - el footer es global: animarlo solo acá lo haría comportarse
    //     distinto que en el resto del sitio;
    //   - la sección text-with-icons YA tiene su propia animación
    //     (lenz-text-with-icons-anim.js). Superponerle esta la dejaba
    //     oculta hasta que su contenedor entrara, peleando con la suya.
    var secciones = main.querySelectorAll('[id^="shopify-section-template--"]');
    if (secciones.length < 2) return;

    var objetivo = [];
    // Arranca en 1: la 0 es el hero (ver cabecera).
    for (var i = 1; i < secciones.length; i++) {
      var s = secciones[i];
      if (!s.offsetHeight) continue; // secciones vacías u ocultas
      objetivo.push(s);
    }
    if (!objetivo.length) return;

    // Sin IntersectionObserver no se oculta nada: la página queda estática
    // pero completa, que es el comportamiento correcto.
    if (!('IntersectionObserver' in window)) return;

    objetivo.forEach(function (s) {
      s.classList.add('lenz-rv');
      marcarHijos(s);
    });

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('lenz-rv--in');
        obs.unobserve(e.target);
      });
    }, {
      // Un umbral bajo con margen negativo abajo: la sección empieza a
      // entrar cuando ya asomó de verdad, no apenas roza el borde.
      threshold: 0.08,
      rootMargin: '0px 0px -8% 0px'
    });

    objetivo.forEach(function (s) { obs.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
